import React from 'react'
import { Button, Form, Input, Modal, Row } from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import _ from 'lodash'

export const HeroConfigForm = ({
  formData,
  heroType,
  visible,
  onClose,
  onOk,
  form
}) => {
  const { validateFields, resetFields, setFieldsValue, getFieldDecorator } =
    form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        locationCount: formData.locationCount,
        radius: formData.radius
      })
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          id: formData.id,
          radius: values.radius,
          locationCount: values.locationCount
        }
        await onOk(data)
        await resetFields()
      }
    })
  }

  return (
    <Modal
      visible={visible}
      title={heroType}
      okText="Save"
      onCancel={onClose}
      footer={null}>
      <Form layout="vertical" onSubmit={onSubmit}>
        <Form.Item label="Max Location">
          {getFieldDecorator(`locationCount`)(
            <Input placeholder="Max Locations" />
          )}
        </Form.Item>
        <Form.Item label="Radius">
          {getFieldDecorator(`radius`)(<Input placeholder="Max Locations" />)}
        </Form.Item>
        <Row justify="end" type="flex">
          <Button type="primary" htmlType="submit">
            บันทึก
          </Button>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedHeroConfigForm = Form.create({
  name: 'HeroConfigForm'
})(HeroConfigForm)

export default WrappedHeroConfigForm



// WEBPACK FOOTER //
// ./src/pages/HeroConfig/components/HeroConfigForm/index.js